module.exports = __webpack_public_path__ + "static/media/53.161f912f.jpg";